import { Button, Modal, Page, TextStyle } from '@superops/ui-design-system';
import React, { useState } from 'react';
import {
  AIActivator,
  getTranslatedText,
  useActivityTracker,
  AI_AGENTS_MAP
} from '@nile/components';
import AggregationTable from '../SectionAdditionalData/AggregationTable';
import { useIntl } from 'react-intl';

function TicketCountCell(props) {
  const { cell } = props;
  const { column, value, row } = cell || {};
  const { meta } = column;
  const intl = useIntl();

  const condition = column?.meta?.condition;

  const defaultCondition = condition?.defaultCondition || [];
  const filterCondition = condition?.filterCondition;

  const clientId = filterCondition?.client?.accountId;

  const [active, setActive] = useState(false);

  return (
    <>
      <Button
        plain
        onClick={() => {
          setActive((prevState) => !prevState);
          useActivityTracker({
            event: 'EFFICIENCY_REPORT_CATEGORY_TICKETLIST',
            data: {
              category: row?.original?.ticketCategory
            }
          });
        }}
      >
        <TextStyle weight="SemiBold">{value}</TextStyle>
      </Button>
      <Modal
        large
        open={active}
        onClose={() => setActive((prevState) => !prevState)}
      >
        <div className="full-height">
          <Page
            variant="secondary"
            contentHeight="80px"
            title={
              <div className="flex g10 actr">
                <div className="flex">
                  Ticket category : {row?.original?.ticketCategory} ({value})
                </div>

                <div className="flex">
                  <AIActivator
                    featureName={AI_AGENTS_MAP.TICKETS_SUMMARY_BY_CATEGORY}
                    buttonText={getTranslatedText(
                      intl,
                      'msp.ai.summarize.ticket.category'
                    )}
                    icon="AIWand"
                    customProps={{
                      variables: {
                        input: {
                          ticketCategory: row?.original?.ticketCategory,
                          client: {
                            accountId: clientId
                          },
                          listInfo: {
                            pageSize: value,
                            page: 1,
                            condition: {
                              joinOperator: 'AND',
                              operands: defaultCondition
                            }
                          }
                        }
                      }
                    }}
                    buttonVariant="aiPrimaryLight"
                    buttonSize="slim"
                    disabledTooltip={getTranslatedText(
                      intl,
                      'msp.ai.ticket.category.summary.disabled.tooltip.message'
                    )}
                  />
                </div>
              </div>
            }
          >
            <AggregationTable
              columns={meta?.columns}
              api={meta?.api}
              minmumHeight
              padded="lg"
              condition={{
                defaultCondition: meta?.condition?.defaultCondition || [],
                filterCondition:
                  {
                    ...meta?.condition?.filterCondition,
                    ticketCategory: row?.original?.ticketCategory
                  } || {},
                hasPagination: true,
                nested: true
              }}
            />
          </Page>
        </div>
      </Modal>
    </>
  );
}

export default TicketCountCell;
